import React from 'react';
import ErrorComponent from './ErrorComponent';

interface ErrorBoundaryProps {
  type: string;
  renderBlank: boolean;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    // Display fallback UI
    this.setState({ hasError: true });
    console.log('catched erro', error);
    console.log('catched info', info);
    // You can also log the error to an error reporting service
  }

  render(): React.ReactNode {
    const { hasError } = this.state;
    const { children, renderBlank = false } = this.props;
    if (hasError) {
      if (renderBlank) {
        return <div />;
      }
      // You can render any custom fallback UI
      return <ErrorComponent errorCode={503} />;
    }
    return children;
  }
}

export default ErrorBoundary;
